var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mt-5"},[_vm._v("Upload Ownership Data")]),_c('ExcelVue',{attrs:{"sheet":_vm.sampleExcel,"fname":_vm.filename}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }